import { SlingoIdleState } from "slingo/states/slingo-idle-state";

export class PopIdleState extends SlingoIdleState {
}